









import Vue from "vue";
import { Component } from "vue-property-decorator";
import TopNavigationBar from "../components/mobile/app-top-navigation-bar/AppTopNavigationBar.vue";
import { AxiosResponse } from "axios";
import { GetUserResponse, UsersApi } from "../../apis";
@Component({
  components: {
    TopNavigationBar,
  },
})
export default class TheLayoutMobile extends Vue {
  get email() {
    return this.$store.getters.user.email;
  }
  get fullName() {
    return this.$store.getters.spUser.fullName;
  }

  mounted() {
    this.$nextTick(() => {
      document
        .querySelectorAll(".permission-container")
        .forEach((container) => {
          if (container.querySelectorAll(".permission-item").length < 1) {
            container.classList.add("tw-hidden");
          }
        });
    });
  }

  created() {
    const responseCb = (val: AxiosResponse<GetUserResponse>) => {
      if (val.status === 200) {
        const { user, permissions } = val.data.data;
        this.$store.commit("SET_USER_INFO", { user });
        this.$store.commit("SET_PERMISSIONS", { permissions });
      }
    };
    if (!this.lodash.isEmpty(this.email)) {
      new UsersApi().getCheckUser({ email: this.email }).then(responseCb);
    }
  }
}
